<template>
    <v-dialog v-model="dialog" max-width="640" scrollable :fullscreen="$store.getters.mobile" content-class="ficha-med">
        <v-card class="ficha">
            <div class="ficha__encabezado">
                <v-icon color="white" class="mr-2">mdi-pill</v-icon>
                <span class="ficha__titulo">Ficha del medicamento</span>
                <v-spacer></v-spacer>
                <v-btn icon color="white" @click="closeModal()" :title="$t('Cerrar')"><v-icon>mdi-close</v-icon></v-btn>
            </div>

            <v-card-text class="ficha__cuerpo" v-if="item">
                <div class="ficha__resumen">
                    <div class="ficha__nombre">{{ item.name }}</div>
                    <div class="ficha__sub" v-if="subtitulo">{{ subtitulo }}</div>
                    <div class="ficha__marcas">
                        <v-chip small label color="orange lighten-4" v-if="item.requires_formula">
                            <v-icon x-small left color="orange darken-2">mdi-prescription</v-icon>Requiere fórmula
                        </v-chip>
                        <v-chip small label color="red lighten-4" v-if="item.controlled_product">
                            <v-icon x-small left color="red">mdi-account-lock</v-icon>Controlado
                        </v-chip>
                        <v-chip small label color="blue lighten-5" v-if="item.fractionable">
                            <v-icon x-small left color="blue">mdi-content-cut</v-icon>Fraccionable
                        </v-chip>
                        <v-chip small label color="grey lighten-3" v-if="item.invima_code">
                            Invima {{ item.invima_code }}
                        </v-chip>
                    </div>
                </div>

                <div class="ficha__seccion">Existencias</div>
                <div class="ficha__existencias" v-if="items.length">
                    <div class="ficha__bodega" v-for="s in items" :key="s.id">
                        <span>{{ s.subsidiary ? s.subsidiary.name : "" }}</span>
                        <strong>{{ s.quantity }}</strong>
                    </div>
                </div>
                <div class="ficha__vacio" v-else>Sin existencias registradas</div>

                <v-expansion-panels multiple flat accordion :value="[0]" class="ficha__paneles">
                    <v-expansion-panel v-for="(sec, i) in secciones" :key="sec.titulo">
                        <v-expansion-panel-header class="ficha__panel-titulo">{{ sec.titulo }}</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div class="ficha__dato" v-for="d in sec.datos" :key="d.etiqueta">
                                <span class="ficha__etiqueta">{{ d.etiqueta }}</span>
                                <span class="ficha__valor">{{ d.valor }}</span>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card-text>
            <v-card-text v-else class="text-center py-8">
                Consultando información ...
                <v-progress-linear indeterminate color="primary" class="mt-3"></v-progress-linear>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions class="ficha__pie">
                <v-btn text large @click="closeModal()">{{ $t("Cerrar") }}</v-btn>
                <v-btn v-if="add" large depressed color="primary" class="ficha__anadir" @click="addItem()">
                    <v-icon left>mdi-package-variant-plus</v-icon>{{ $t("Añadir") }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false,
            item: null,
            add: true,
            product: null,
            items: []
        };
    },
    computed: {
        subtitulo() {
            const i = this.item || {};
            return [i.active_ingredient, i.concentration, i.pharmaceutical_form, i.presentation].filter(Boolean).join(" · ");
        },
        // Secciones de la ficha: solo salen los datos que traen valor (antes quedaban filas vacías).
        secciones() {
            const i = this.item || {};
            const si = (v) => (v === true || v === 1 || v === "1" ? "Sí" : v === false || v === 0 || v === "0" ? "No" : "");
            const def = [
                ["Información técnica", [
                    ["active_ingredient", i.active_ingredient], ["concentration", i.concentration], ["content", i.cm_content],
                    ["presentation", i.presentation], ["pharmaceutical_form", i.pharmaceutical_form], ["therapy_class", i.therapy_class],
                    ["way_administration", i.way_administration], ["storage_temperature", i.storage_temperature],
                    ["fractionable", si(i.fractionable)], ["bonus_product", si(i.bonus_product)],
                    ["requires_formula", si(i.requires_formula)], ["pum", si(i.pum)],
                ]],
                ["Datos básicos", [
                    ["code", i.code], ["ean", i.ean], ["name", i.name], ["provider_name", i.provider_name],
                    ["generic_brand", i.generic_brand], ["trademark", i.trademark],
                ]],
                ["Reglamento Invima", [
                    ["invima_code", i.invima_code],
                    ["invima_expiration_date", i.invima_expiration_date ? this.$filters.date(i.invima_expiration_date) : ""],
                ]],
                ["Categorización", [
                    ["group", i.group], ["category", i.category], ["subcategory", i.subcategory], ["classification", i.classification],
                ]],
                ["Descripciones", [
                    ["atci_description", i.atci_description], ["atcii_description", i.atcii_description], ["atciii_description", i.atciii_description],
                ]],
            ];
            return def
                .map(([titulo, filas]) => ({
                    titulo,
                    datos: filas.filter(([, v]) => v !== null && v !== undefined && v !== "").map(([k, v]) => ({ etiqueta: this.$t(k), valor: v })),
                }))
                .filter((s) => s.datos.length);
        },
    },
    methods: {
        renderItem(medication, add = true) {
            this.dialog = true;
            this.add = add;
            this.getInfo(medication);
        },
        async getInfo(medication) {
            this.product = medication;
            this.item = medication.info_medication;
            this.items = [];
            this.$http.get('api/v1/stock', { product: { id: medication.id } }).then((response) => {
                if (response.success) {
                    this.items = response.items;
                }
            })
        },
        addItem() {
            this.$emit("add:item", this.product);
            this.closeModal();
        },
        closeModal() {
            this.item = null;
            this.add = true;
            this.dialog = false;
        },
    },
};
</script>

<style>
.ficha__encabezado {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    height: 56px;
    padding: 0 8px 0 16px;
    color: #fff;
    background: var(--pos-encabezado);
}

.ficha__titulo {
    font-size: 1.2rem;
    font-weight: 500;
}

.ficha__cuerpo {
    padding: 0 !important;
}

.ficha__resumen {
    padding: 16px;
    background: #f6f7f8;
}

.ficha__nombre {
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1.25;
}

.ficha__sub {
    margin-top: 4px;
    color: rgba(0, 0, 0, 0.65);
}

.ficha__marcas {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 10px;
}

.ficha__seccion {
    padding: 14px 16px 6px;
    font-size: 0.78rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.6);
}

.ficha__existencias {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 8px;
    padding: 0 16px 8px;
}

.ficha__bodega {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    border: 1.5px solid rgba(0, 0, 0, 0.12);
    border-radius: 10px;
}

.ficha__bodega strong {
    font-size: 1.1rem;
}

.ficha__vacio {
    padding: 0 16px 8px;
    color: rgba(0, 0, 0, 0.5);
}

.ficha__paneles {
    margin-top: 8px;
}

.ficha__panel-titulo {
    font-weight: 600;
}

.ficha__dato {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 6px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.ficha__etiqueta {
    flex: 0 0 42%;
    color: rgba(0, 0, 0, 0.6);
}

.ficha__valor {
    flex: 1;
    text-align: right;
    word-break: break-word;
}

.ficha__pie {
    gap: 8px;
    padding: 10px 12px calc(10px + env(safe-area-inset-bottom)) !important;
}

.ficha__anadir {
    flex: 1 1 auto;
    min-height: 48px !important;
    font-weight: 700;
}

.__list-item-icon {
    background: #e3f2fd !important;
    border-radius: 50%;
    padding: 12px;
}
</style>
